<template>
    <div>
        <div class="modal fade" id="copiarModal" tabindex="-1" aria-labelledby="copiarModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="copiarModalLabel">Copiar Reglas de cobro</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="ciclo_destino">Ciclo escolar origen</label>
                            <select class="form-control" id="ciclo_destino" v-model="ciclo">
                                <option v-for="ciclo in ciclos" :key="ciclo.id" :value="ciclo.id">{{ ciclo.text }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label for="ciclo_destino">Ciclo escolar destino</label>
                            <select class="form-control" id="ciclo_destino" v-model="destCiclo">
                                <option v-for="ciclo in destCiclos" :key="ciclo.id" :value="ciclo.id">{{ ciclo.text }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="!working" type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button v-if="!working" type="button" class="btn btn-primary" @click="save">Guardar</button>

                        <div v-if="working" class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="position-fixed bottom-0 right-0 p-3" style="z-index: 5; right: 0; bottom: 0;">
            <div id="copy-reglas-toast" class="toast hide" role="alert" aria-live="assertive" aria-atomic="true" data-delay="5000">
                <div class="toast-header">
                    <strong class="mr-auto">Éxito</strong>
                    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="toast-body">
                    Reglas de cobro agregadas.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            institucion: {
                type: Number,
                default: 0
            }
        },
        computed: {
            propsChange() {
                return `${this.institucion}|${this.ciclo}`;
            },
            destCiclos() {
                return this.ciclos.filter(c => c.id != this.ciclo);
            }
        },
        watch: {
            async propsChange(newValue, oldValue) {
                let response = await axios.get(`/ciclos-escolares/ciclosPorInstitucion/${this.institucion}`);
                this.ciclos = response.data;
            }
        },
        data() {
            return {
                ciclos: [],
                destCiclo: 0,
                working: false,
                ciclo: 0
            }
        },
        methods: {
            save() {
                this.working = true;

                axios.post('/reglas-de-cobro/copiar', {
                    institucion: this.institucion,
                    ciclo: this.ciclo,
                    destCiclo: this.destCiclo
                }).then(response => {
                    $('#copiarModal').modal('hide');
                    this.working = false;
                    $('#copy-reglas-toast').toast('show');
                }).catch(ex => {
                    console.error(ex);
                    this.working = false;
                    alert('Error al agregar reglas de cobro');
                    $('#copiarModal').modal('hide');
                });
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
